import { object, string, date, number } from "yup";

export const NiveauFidSchema = object({
  libelle: string().required("LIbelle obligatoire !"),
  pointsMin: number().required("points obligatoire"),
});
